import React from 'react'
import { useAuth } from '@webmotors/consumer-shared-auth'
import { Footer as UIFooter } from '@webmotors/consumer-shared-ui'
import { config } from 'config/config'

const Footer = () => {
  const { token } = useAuth()
  const authToken = token ?? undefined

  return (
    <UIFooter
      copiAuthToken={authToken}
      baseUrl={config.baseUrl}
      enableCookieManagement
      dataQaProject="da"
    />
  )
}

export default Footer
